export default __webpack_public_path__ + "static/media/photo--lg--misc-19.5d744f11.jpg";